import axios from 'axios';

/** тип передаваемых параметров для обратной совместимости с методом checkConnection (нужен, если fiasId не пришел) */

/** параметры запроса */

/** метод проверки доступности подключения адреса, включая проверку доступности цветных тарифов () */
export var checkHouseConnection = function checkHouseConnection(params) {
  return axios.post('/api/home/check-connection/house-info/', params).then(function (_ref) {
    var data = _ref.data;
    return data;
  });
};